import { 
    ACTUALIZAR_LIST_NIVEL5,
    AGREGAR_NIVEL5,
  } from "./nivel5Actions";

  const nivel5Reducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_NIVEL5: {
            return {
                ...state,
                nivel5List: action.payload
            }
        };

        case AGREGAR_NIVEL5:{
            return {
                 ...state,
                 nivel5List: [action.payload, ...state.nivel5List]
             }
         };

        default:
            return state;

    }
  }

  export default nivel5Reducer;